angular.module('callX').controller('ViewAccountCtrl', ['$scope', 'UserService', 'toaster', function($scope, UserService, toaster) {

    $scope.changePassword = {};

    $scope.$on('currentUserUpdate', function(event, currentUserData) {
        $scope.currentUserData = currentUserData;
    });
    $scope.currentUserData = UserService.getCurrentUserData();
    var loggedUser = $scope.currentUserData.user_id;
    //console.log(loggedUser,"this is the id")
    $scope.fetchAlertsInformation = function(loggedUser){
        var callbacks = {
            success: function(data) {
                //console.log("hey")
                $scope.alertsUser = data.data;
                //console.log($scope.alertsUser,"this alert get information")
                $scope.emailAlert = $scope.alertsUser.email_alert.toString();
                //console.log($scope.emailAlert,"this is the emailAlert")
                $scope.notificationAlert = $scope.alertsUser.notification_alert.toString();
                //console.log($scope.notificationAlert,"this is notificationAlert")
                
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.getAlertsData(loggedUser,callbacks);
    };
    $scope.fetchAlertsInformation(loggedUser);

    $scope.putAlertsInformation =  function(notificationAlert,emailAlert,loggedUser2,callbacks){
        //console.log(loggedUser2,"this is loggedUser")
        var callbacks = {
            success: function(data) {
                $scope.alertsUserGet = data.data;
                //console.log($scope.alertsUserGet,"this alert information after putting")
                $scope.fetchAlertsInformation(loggedUser);
                toaster.pop('success', 'Success', 'Your changes saved!', 2000);
            },
            failure: function(data) {
                toaster.pop('error', 'Error', data.data);
            }
        };
        UserService.putAlertsData(notificationAlert,emailAlert,loggedUser2,callbacks);
    };

    $scope.updatePassword = function () {
        if ($scope.changePassword.newPassword == undefined) {
            toaster.pop('error', 'New Password',  'New Password is required.', 2000);
        }

        else if ($scope.changePassword.confirmNewPassword == undefined) {
            toaster.pop('error', 'Confirm New Password', 'Confirm New Password is required', 2000);
        }

        else{

            if($scope.changePassword.newPassword != $scope.changePassword.confirmNewPassword){
                toaster.pop('error', 'Passwords do not match', 'Password & Confirm new password do not match', 2000);
            }

            else{
                var callbacks = {
                    success: function (data) {
                        toaster.pop('success', 'Success', 'Password successfully updated', 2000);
                        $scope.showUpdatePassword = false;
                        $scope.changePassword = {};
                    },
                    failure: function (data) {
                        toaster.pop('error', 'Error', data.data);
                    }
                };
                UserService.updateUserPassword($scope.currentUserData.id, {password: $scope.changePassword.newPassword}, callbacks);
            }
        }
    };

}]);